import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useTopicPageViewsTopicGlobalHandlers from "../useTopicPageViewsTopicGlobalHandlers";
import useTopicPageViewsTopicEditorGlobalHandlers from "../useTopicPageViewsTopicEditorGlobalHandlers";
import TopicPageViewsTopicListMemo from "./TopicPage_Views_Topic_List_Memo";
import TopicPageViewsTopicListSettings from "./TopicPageViewsTopicListSettings";
const TopicPageViewsTopicList = (props)=>{
    const { topic  } = props;
    const dialogsToRender = useTopicPageViewsTopicGlobalHandlers({
        topic
    });
    useTopicPageViewsTopicEditorGlobalHandlers({
        topic
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            dialogsToRender,
            /*#__PURE__*/ _jsx(TopicPageViewsTopicListMemo, {
                topic: topic
            }),
            /*#__PURE__*/ _jsx(TopicPageViewsTopicListSettings, {
                topic: topic
            })
        ]
    });
};
export default TopicPageViewsTopicList;
